import React, { useState } from "react";
import "./ArtifactCard.scss";
import { BsPlus } from "react-icons/bs";
import { FaChevronLeft } from "react-icons/fa6";
import { Form } from "react-bootstrap";
import { CiCircleMinus } from "react-icons/ci";
import replace from "../../assets/images/category/replace.png";
import { RiCloseFill } from "react-icons/ri";
import { Tooltip } from "@mui/material";
import { HiOutlinePlus } from "react-icons/hi";

const ArtifactCard = ({
  artifactArray,
  artifact,
  conditionDegradationChangeHandler,
  conditionDegradationBlur,
  stratIndex,
  artifactIndex,
  stratData,
  strategicDetailsAddHandler,
  formik,
  strategicDetailRemoveHandler,
  strategicEvidenceImageAddHandler,
  strategicEvidenceImageChangeHandler,
  setShowEnlargeImage,
  removestrategicEvidenceImageChangeHandler,
  setIsAutoSave,
}) => {
  const [currentImage, setCurrentImage] = useState(artifact.mainImage);

  const handleDropImageChange = (
    e,
    stratIndex,
    artifactIndex,
    indexOfgraph
  ) => {
    setIsAutoSave(true);

    let data =
      e?.dataTransfer?.getData("application/json") ||
      e?.dataTransfer?.getData("text/plain");
    const { thumbnailUrl, imageUrl, caption } = JSON.parse(data);

    const strategicList = [...formik?.values?.stratigraphic_assessment];
    strategicList[stratIndex].assessment_details[artifactIndex].evidence_images[
      indexOfgraph
    ].image = imageUrl;
    strategicList[stratIndex].assessment_details[artifactIndex].evidence_images[
      indexOfgraph
    ].caption = caption;
    strategicList[stratIndex].assessment_details[artifactIndex].evidence_images[
      indexOfgraph
    ].image_changed = true;
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: strategicList,
    });
  };

  return (
    <div className="artifact-card">
      {/* Left Column: Images */}

      {/* Right Column: Details */}
      <div className="artifact-card__details-section">
        <div style={{ width: "100%" }}>
          <Form.Group className="artifact-card__title">
            <Form.Control
              value={artifact.degradation}
              type="text"
              placeholder="Degradation name"
              onBlur={(e) =>
                conditionDegradationBlur(
                  e,
                  stratIndex,
                  artifactIndex,
                  stratData
                )
              }
              onChange={(e) =>
                conditionDegradationChangeHandler(
                  e,
                  stratIndex,
                  artifactIndex,
                  stratData
                )
              }
            />
          </Form.Group>
          <div className="artifact-card__gallery-section">
            {/* Gallery Strip */}
            <div className="artifact-card__gallery-strip">
              <div className="artifact-card__gallery-scroll">
                <div className="artifact-card__gallery-nav-btn">
                  {/* <svg
                  onClick={() =>
                    strategicEvidenceImageAddHandler(stratIndex, artifactIndex)
                  }
                  style={{
                    cursor: "pointer",
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                >
                  <path
                    d="M21.8657 12.8036H14.1969V5.13477H12.8026V12.8036H5.13379V14.1979H12.8026V21.8667H14.1969V14.1979H21.8657V12.8036Z"
                    fill="#20409A"
                  />
                  <circle
                    cx="13.5"
                    cy="13.5"
                    r="12.75"
                    stroke="#20409A"
                    stroke-width="1.5"
                  />
                </svg>{" "} */}
                  <div
                    className="img-adding-div conservat-img-div "
                    onMouseDown={(e) => {
                      if (e.detail > 1) {
                        e.preventDefault();
                      }
                    }}
                    onClick={() =>
                      strategicEvidenceImageAddHandler(
                        stratIndex,
                        artifactIndex
                      )
                    }
                  >
                    <HiOutlinePlus color="#092159e4" />
                  </div>
                  <p
                    style={{
                      fontSize: "small",
                      userSelect: "none",
                    }}
                  >{`(${artifact?.evidence_images?.length}/10)`}</p>
                </div>
                {artifact.evidence_images.map((img, indexOfgraph) => {
                  return img.image ? (
                    <div
                      style={{ position: "relative" }}
                      key={img.id}
                      onDragOver={(e) => {
                        e.preventDefault();
                      }}
                      onDrop={(e) =>
                        handleDropImageChange(
                          e,
                          stratIndex,
                          artifactIndex,
                          indexOfgraph
                        )
                      }
                      onClick={() =>
                        setShowEnlargeImage({
                          show: true,
                          title: "Condition assessment",
                          image: img.image,
                          imageIdTitle: "file-input",
                          imageIndex: indexOfgraph,
                          parentIndex: stratIndex,
                          childIndex: artifactIndex,
                          isEdit: true,
                        })
                      }
                      className={`artifact-card__gallery-thumb`}
                    >
                      <div className="artifact-card__gallery-thumb-image">
                        <div style={{}} className="display-image">
                          <img
                            src={img.image}
                            //   alt={img.caption}
                            style={{
                              objectFit: "contain",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </div>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <Form.Control
                            type="text"
                            placeholder="Caption"
                            value={img.caption}
                            name={`stratigraphic_assessment[${stratIndex}].assessment_details[${artifactIndex}].evidence_images[${indexOfgraph}].caption`}
                            onChange={(e) => {
                              formik.handleChange(e);
                              setIsAutoSave(true);
                            }}
                          />
                        </div>
                      </div>
                      <Form.Control
                        type="file"
                        id={`file-input-${stratIndex}-${artifactIndex}-${indexOfgraph}`}
                        style={{
                          display: "none",
                        }}
                        onChange={(e) =>
                          strategicEvidenceImageChangeHandler(
                            e,
                            stratIndex,
                            artifactIndex,
                            indexOfgraph
                          )
                        }
                        accept=".jpeg,.jpg,.png"
                      />

                      <div
                        className="delete_icon-cons"
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-7px",
                          backgroundColor: "#20409A",
                          borderRadius: "50%",
                          display: "flex",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          removestrategicEvidenceImageChangeHandler(
                            stratIndex,
                            artifactIndex,
                            indexOfgraph
                          );
                        }}
                      >
                        <RiCloseFill
                          size={15}
                          style={{
                            strokeWidth: 2,
                            cursor: "pointer",
                            color: "white",
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="img-upload"
                      onDragOver={(e) => {
                        e.preventDefault();
                      }}
                      onDrop={(e) =>
                        handleDropImageChange(
                          e,
                          stratIndex,
                          artifactIndex,
                          indexOfgraph
                        )
                      }
                      onClick={() =>
                        document
                          .getElementById(
                            `file-input-${stratIndex}-${artifactIndex}-${indexOfgraph}`
                          )
                          .click()
                      }
                    >
                      <div className="replace-logo-div">
                        <img
                          style={{
                            height: "20%",
                            width: "20%",
                          }}
                          className="replace-logo"
                          src={replace}
                          alt="logo"
                        ></img>
                      </div>
                      <Form.Control
                        type="file"
                        id={`file-input-${stratIndex}-${artifactIndex}-${indexOfgraph}`}
                        style={{
                          display: "none",
                        }}
                        onChange={(e) =>
                          strategicEvidenceImageChangeHandler(
                            e,
                            stratIndex,
                            artifactIndex,
                            indexOfgraph
                          )
                        }
                        accept=".jpeg,.jpg,.png"
                      />

                      <div
                        style={{
                          position: "absolute",
                          top: "-9px",
                          right: "-9px",
                          backgroundColor: "#20409A",
                          borderRadius: "50%",
                          display: "flex",
                        }}
                        className="delete_icon-cons"
                        onClick={(e) => {
                          e.stopPropagation();
                          removestrategicEvidenceImageChangeHandler(
                            stratIndex,
                            artifactIndex,
                            indexOfgraph
                          );
                        }}
                      >
                        <RiCloseFill
                          size={15}
                          style={{
                            strokeWidth: 2,
                            color: "white",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div>
            <Form.Control
              as={"textarea"}
              value={artifact.description}
              onChange={(e) => {
                formik.handleChange(e);
                setIsAutoSave(true);
              }}
              placeholder="Description"
              className="artifact-card__description"
              name={`stratigraphic_assessment[${stratIndex}].assessment_details[${artifactIndex}].description`}
              style={{
                fontSize: "16px",
                color: "black",
              }}
            />
          </div>
        </div>
        {formik?.values?.stratigraphic_assessment[stratIndex]
          ?.assessment_details?.length > 1 && (
          <Tooltip title="Remove degradation">
            <div>
              <CiCircleMinus
                style={{
                  cursor: "pointer",
                  fontSize: "31px",
                  color: "#20409A",
                }}
                onClick={() =>
                  strategicDetailRemoveHandler(stratIndex, artifactIndex)
                }
              />
            </div>
          </Tooltip>
        )}
      </div>

      <div
        style={{ position: "absolute", right: "0", top: "0" }}
        className="strategic-details-icon-container"
      >
        <div className="proposed-icons"></div>
      </div>
      <div className="add-degradation-button"></div>
    </div>
  );
};

export default ArtifactCard;
